export default __webpack_public_path__ + "static/media/edit.bfc03d5b.svg";